<template>
    <v-layout row justify-center>
        <v-dialog
            v-model="dialog"
            persistent
            scrollable
            max-width="90%"
            transition="dialog-transition"
            content-class="v-dialog--large"
        >
            <v-card>
                <v-card-title class="teal darken-2">
                    <span class="title" style="color: #fff;">{{ $t("selectCuts") }}</span>
                </v-card-title>
<!--
                <v-card-title :class="{'grey lighten-4': !this.$vuetify.dark, 'grey darken-4': this.$vuetify.dark}">
                    <span class="headline">{{ $t("selectCuts") }}</span>
                </v-card-title>
-->
                <v-divider></v-divider>

                <v-progress-linear color="green" :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>

                <v-card-text class="pa-0">
                    <v-layout row wrap>
                        <v-flex xs12 px-3>
                            <v-select
                                :label="$t('lumberGroup')"
                                :items="groups"
                                item-text="name"
                                item-value="id"
                                prepend-icon="mdi-view-module"
                                v-model="selectedGroupId"
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 px-3>
                            <v-checkbox
                                v-model="useCentralAsSide"
                                :label="$t('usingCentralAsSide')"
                                hide-details
                            ></v-checkbox>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap mb-2>
                        <v-flex xs12 md6>
                            <v-card class="elevation-0">
                                <v-card-title>
                                    <span class="font-weight-black">{{ $t("centralBoards") }}</span>
                                </v-card-title>
                                <v-card-text class="dense">
                                    <template>
                                        <v-data-table
                                            v-model="centralBoardsSelected"
                                            item-key="uid"
                                            :headers="boardsHeader"
                                            :items="boardsCentral"
                                            :rows-per-page-items="[100]"
                                            select-all
                                            hide-actions
                                            class="dense-table"
                                        >
                                            <template v-slot:items="props">
                                                <td>
                                                    <v-checkbox
                                                        v-model="props.selected"
                                                        primary
                                                        hide-details
                                                    ></v-checkbox>
                                                </td>
                                                <td>{{ props.item.size }}</td>
                                                <td>{{ props.item.sawSize }}</td>
                                                <td>{{ props.item.length }}</td>
                                                <td class="text-xs-right">{{ props.item.price }}</td>
                                                <td class="text-xs-right">{{ props.item.expenses }}</td>
                                            </template>
                                        </v-data-table>
                                    </template>
                                </v-card-text>
                            </v-card>
                        </v-flex>

                        <v-flex xs12 md6>
                            <v-card class="elevation-0">
                                <v-card-title>
                                    <span class="font-weight-black">{{ $t("sideBoards") }}</span>
                                </v-card-title>
                                <v-card-text class="dense">
                                    <template>
                                        <v-data-table
                                            v-model="sideBoardsSelected"
                                            item-key="uid"
                                            :headers="boardsHeader"
                                            :items="boardsSide"
                                            :rows-per-page-items="[100]"
                                            select-all
                                            hide-actions
                                            class="dense-table"
                                        >
                                            <template v-slot:items="props">
                                                <td>
                                                    <v-checkbox
                                                        v-model="props.selected"
                                                        primary
                                                        hide-details
                                                    ></v-checkbox>
                                                </td>
                                                <td>{{ props.item.size }}</td>
                                                <td>{{ props.item.sawSize }}</td>
                                                <td>{{ props.item.length }}</td>
                                                <td class="text-xs-right">{{ props.item.price }}</td>
                                                <td class="text-xs-right">{{ props.item.expenses }}</td>
                                            </template>
                                        </v-data-table>
                                    </template>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions :class="{'grey lighten-4': !this.$vuetify.dark, 'grey darken-4': this.$vuetify.dark}">
                    <v-spacer></v-spacer>
                    <!--
                    <v-btn color="green darken-1" flat @click="saveDataClick">{{ $t("save") }}</v-btn>
                    <v-btn color="blue darken-1" flat @click="dialog = false">{{ $t("cancel") }}</v-btn>
                    -->
                    <v-btn color="success" @click="saveDataClick">{{ $t("apply") }}</v-btn>
                    <v-btn color="error" @click="dialog = false">{{ $t("cancel") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <message-box ref="MessageBox"/>
    </v-layout>
</template>

<script>
    import MessageBox from "./MessageBox";

    export default {
        name: "SelectCutsDialog",

        components: {
            MessageBox
        },

        data () {
            return {
                dialog: false,

                loading: {
                    groups: false,
                    lumber: false,

                },

                apply: false,
                //centralBoards: [],
                centralBoardsSelected: [],
                //sideBoards: [],
                sideBoardsSelected: [],
                //selectedSideBoards: [],
                speciesId: 0,

                boardsHeader: [
                    { text: "Сечение",        value: "size",    align: "left", sortable: true },
                    { text: "Пильный размер", value: "sawSize", align: "left", sortable: true },
                    { text: "Длина, м",       value: "length",  align: "left" },
                    { text: "Цена за м3",     value: "price",   align: "left", sortable: true },
                ],
                boardsCentral: [],
                boardsSide: [],

                groups: [],
                selectedGroupId: 0,
                useCentralAsSide: false
            }
        },

        /*
        computed: {
            computedHeaders () {
                if (this.hideIDs) {
                    return this.headers.filter(
                        header => header.text !== "id" &&
                        header.text !== "speciesId" &&
                        header.text !== "Tn" &&
                        header.text !== "Wn" &&
                        header.text !== "Ts" &&
                        header.text !== "Ws"
                    );
                }

                return this.headers;
            }
        },
        */

        mounted () {
            this.applyLocale();
            //this.loadLumber();
            //this.loadGroups();

            this.$root.$on("localeChanged", () => { this.applyLocale(); });
        },

        computed: {
            progressBarVisible() {
                return this.loading.groups || this.loading.lumber;
            },
        },

        watch: {
            /* При показе формы сбрасываем флаг изменения данных */
            dialog: function (val) {
                if (val) {
                    this.apply = false;
                    this.loadLumber();
                    this.loadGroups();
                    this.useCentralAsSide = localStorage.useCentralAsSide ? JSON.parse(localStorage.useCentralAsSide) : false;
                }
            },

            selectedGroupId: function (val) {
                let ids = this.groups.filter(data => data.id == val).length > 0
                    ? this.groups.filter(data => data.id == val)[0].lumberIds
                    : [];
                this.sideBoardsSelected    = this.boardsSide.filter(data => ids.includes(data.id));
                this.centralBoardsSelected = this.boardsCentral.filter(data => ids.includes(data.id));
            },

            speciesId: function () { this.loadLumber(); },
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.boardsHeader = [
                    { text: this.$t("dimension"), value: "size",    align: "left", sortable: true },
                    { text: this.$t("sawSize"),   value: "sawSize", align: "left", sortable: true },
                    {
                        text:  this.$t("length") + ", " + this.$t("m"),
                        value: "length",
                        align: "left"
                    },
                    { text: this.$t("priceM3"), value: "price", align: "right", sortable: true },
                    { text: this.$t("expensesM3"), value: "expenses", align: "right", sortable: true },
                ];
            },

            /**
             * Загрузка групп пиломатериалов
             */
            loadGroups () {
                this.loading.groups = true;

                this.axios.get(`${this.$config.apiURL}lumber_groups/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let groups = response.data.groups;

                            this.groups = [];

                            this.groups.push({
                                id:        0,
                                name:      this.$t("noGroup"),
                                speciesId: this.speciesId,
                                lumberIds: [],
                            });

                            groups.forEach((item) => {
                                if (item.Species.id == this.speciesId) {
                                    let lumberIds = [];
                                    item.LumberGroupsData.forEach(data => {
                                        lumberIds.push(parseInt(data.LumberId));
                                    });
                                    this.groups.push({
                                        id:        item.id,
                                        name:      item.Name,
                                        speciesId: item.Species.id,
                                        lumberIds: lumberIds,
                                    });
                                }
                            });
                        }

                        this.loading.groups = false;
                    })
                    .catch(error => {
                        this.loading.groups = false;

                        this.$debug.error(error);

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadGroupsData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadGroupsData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadGroupsData"));
                        }
                    });
            },

            /**
             * Загрузка справочника пиломатериалов
             */
            loadLumber () {
                this.loading.lumber = true;

                this.axios.get(`${this.$config.apiURL}lumber/`, { withCredentials: true })
                    .then(response => {
                        this.loading.lumber = false;
                        if (response.data.status == "success") {
                            let lumberInfo = response.data.lumber;

                            this.boardsCentral = [];
                            this.boardsSide    = [];

                            lumberInfo.forEach((item) => {
                                let lengthsList = "";

                                JSON.parse(item.LengthsJSON).forEach((lenItem, index) => {
                                    lengthsList += index ? ", " : "";
                                    lengthsList += lenItem.length.slice(0, -1);
                                });

                                // Меняем значения стандартных сечений на ознакомительной подписке
                                if (this.$store.getters.subscription.id == 1) {
                                    item.Tn += 2;
                                    item.Wn += 2;
                                    item.Ts = parseFloat(item.Ts) + 2;
                                    item.Ws = parseFloat(item.Ws) + 2;
                                }

                                if (item.BoardType && this.speciesId == item.Species.id) {
                                    this.boardsSide.push({
                                        id:      item.id,
                                        uid:     item.BoardType ? "s" + item.id : "c" + item.id,
                                        size:    item.Tn + " x " + item.Wn,
                                        sawSize: item.Ts + " x " + item.Ws,
                                        length:  lengthsList,
                                        price:   item.Price,
                                        expenses:        item.Expenses == undefined ? 0 : item.Expenses,
                                        //speciesId:       item.Species.id,
                                        //species:         lumberMan.$t(item.Species.Name),
                                        //Tn:              item.Tn,
                                        //Wn:              item.Wn,
                                        //Ts:              item.Ts,
                                        //Ws:              item.Ws,
                                        //boardType:      item.BoardType,
                                        //boardType:       item.BoardType == 0 ? lumberMan.$t("centralBoard") : lumberMan.$t("sideBoard"),
                                        //isCentralBoard:  item.BoardType == 0,
                                        selectedLengths: JSON.parse(item.LengthsJSON)
                                    });
                                } else if (this.speciesId == item.Species.id) {
                                    this.boardsCentral.push({
                                        id:      item.id,
                                        uid:     item.BoardType ? "s" + item.id : "c" + item.id,
                                        size:    item.Tn + " x " + item.Wn,
                                        sawSize: item.Ts + " x " + item.Ws,
                                        length:  lengthsList,
                                        price:   item.Price,
                                        expenses:        item.Expenses == undefined ? 0 : item.Expenses,
                                        //speciesId:       item.Species.id,
                                        //species:         lumberMan.$t(item.Species.Name),
                                        //Tn:              item.Tn,
                                        //Wn:              item.Wn,
                                        //Ts:              item.Ts,
                                        //Ws:              item.Ws,
                                        //boardType:      item.BoardType,
                                        //boardType:       item.BoardType == 0 ? lumberMan.$t("centralBoard") : lumberMan.$t("sideBoard"),
                                        //isCentralBoard:  item.BoardType == 0,
                                        selectedLengths: JSON.parse(item.LengthsJSON)
                                    });
                                }
                            });
                        }
                    })
                    .catch(err => {
                        this.loading.lumber = false;
                        this.$refs.MessageBox.title       = this.$t("error");
                        this.$refs.MessageBox.messageText = this.$t("cantLoadLumberData");
                        this.$refs.MessageBox.dialog      = true;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `SelectCutsDialog.vue -> loadLumber: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });
                    });
            },

            /**
             * Сброс параметров формы
             */
            resetForm () {
                //this.centralBoards = [];
                //this.sideBoards    = [];
                this.centralBoardsSelected = [];
                this.sideBoardsSelected    = [];
                this.speciesId             = 0;
                this.boardsCentral         = [];
                this.boardsSide            = [];
                this.groups                = [];
                this.selectedGroupId       = 0;
            },

            /**
             * Обработчик нажатия кнопки сохранения
             */
            saveDataClick () {
                this.apply  = true;
                this.dialog = false;
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },
        }
    }
</script>
